module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Mail-unocked-850590cbce36fed610919b440f7aa867.svg";